//TODO: Musi poczekać, bo jest zależne od innych modułów w tej libce

import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface ProductsGetAssociatedEInvoiceSymbolsQueryParams {
    clientId: number;
    eInvoiceItemsSymbols: string[]
}

export interface PurchaseGetMatchedProductsToEInvoiceItem {
    eInvoiceSymbol: string,
    symbol: string;
    productId: number;
    productName: string;
    purchaseVatRateId: number;
    unitId: number;
    includesInventoryControl: boolean;
}

export class ProductsGetAssociatedEInvoiceSymbolsQuery extends Query<PurchaseGetMatchedProductsToEInvoiceItem[]> {
    public constructor(public readonly params: ProductsGetAssociatedEInvoiceSymbolsQueryParams) {
        super();
    }
}

export class ProductsGetAssociatedEInvoiceSymbolsQueryHandlerBase implements QueryHandler<ProductsGetAssociatedEInvoiceSymbolsQuery> {
    private static Url = TaggedUrl.join('products/associatedEInvoiceSymbols', [Tags.Api]);
    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: ProductsGetAssociatedEInvoiceSymbolsQuery): Promise<PurchaseGetMatchedProductsToEInvoiceItem[]> {
        try {
            const { data } = await this.http.get(ProductsGetAssociatedEInvoiceSymbolsQueryHandlerBase.Url, {
                params
            });

            return data;
        } catch (err) {
            this.logger.error(err);
            return [];
        }
    }
}
